export enum PlaceToType {
  PlaceToFirstChildItem = 1,
  PlaceToLastChildItem = 2
}
